export const env = {
  sheetsWebhookUrl: import.meta.env.VITE_SHEETS_WEBHOOK_URL ?? "",
  ga4Id: import.meta.env.VITE_GA4_ID ?? "",
  clarityId: import.meta.env.VITE_CLARITY_ID ?? "",
};

export const hasSheets = () => env.sheetsWebhookUrl.length > 0;
